import { useEffect, useState } from 'react';
import { creditBalance } from '../../api/billing';
import { freeWeekRunning } from '../../state/trial';
import FreeWeekOffer from './FreeWeekOffer';
import { cameBackLater, markSeenThisVisit } from '../../state/liveSeen';

/**
 * The offer to keep it live, in the editor (V6): when its owner comes back on a later visit while
 * the free week runs, for the free week's own app (`/credits` `freeWeek.appId`). Once per visit, and
 * never on a timer. Asks the server nothing unless this app's live screen was seen on an earlier visit.
 */
export default function FreeWeekNudge({ projectId, appId, appName, ownerId }: {
  projectId: string;
  /** The web app's own id (the definition's). */
  appId: string;
  appName: string;
  ownerId: string;
}) {
  const [until, setUntil] = useState<string | null>(null);
  useEffect(() => {
    if (!cameBackLater(projectId)) return;
    let live = true;
    creditBalance().then(
      (b) => {
        if (!live) return;
        // Marked once answered, not before: StrictMode's second run must still be able to ask.
        markSeenThisVisit(projectId);
        if (b.freeWeek?.appId === appId && freeWeekRunning(b)) setUntil(b.freeWeek.until);
      },
      () => undefined,
    );
    return () => {
      live = false;
    };
  }, [projectId, appId]);

  if (!until) return null;
  return <FreeWeekOffer appName={appName} until={until} appId={appId} ownerId={ownerId} onClose={() => setUntil(null)} />;
}
